import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import { withStyles } from 'theme/withStyles';

import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';

import ButtonRowGroup from './common/ButtonRowGroup';

import commonStyles from './styles';
import fundingButtonRowStyles from './styles/fundingButtonRow';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    fundingButtonRow: fundingButtonRowStyles(theme),
  };
};

const FundingCCBare = ({
  bottomContent,
  children,
  classes,
  hasFields,
  label,
  labelMobile,
  name,
  subText,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <div className={classnames('funding-cc-group-view', classes.fundingButtonRow)}>
      <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

      <ErrorMsg name={name} type="group" />

      <div className={classnames('region-fields', classes.fields)}>{children}</div>

      <BottomContent className="bottomContent">{bottomContent}</BottomContent>

      <ButtonRowGroup groupName={name} />
    </div>
  </>
);

FundingCCBare.propTypes = {
  bottomContent: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  subText: PropTypes.string,
};

FundingCCBare.defaultProps = {
  bottomContent: '',
  hasFields: false,
  label: '',
  labelMobile: '',
  subText: '',
};

const FundingCCStyled = withStyles(styles)(FundingCCBare);

const mapStateToProps = ({ groups }, { name }) => {
  const group = groups[name];
  return {
    bottomContent: group.bottomContent,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    subText: group.subText,
  };
};

export default connect(mapStateToProps)(FundingCCStyled);
